import angular from 'angular'

import { VD_EVENTS } from '../../constants'

const VD_OVERLAY_TEMPLATE = '<div class="vd-overlay vd-overlay--visible"></div>'

angular
  .module('vend.ui')
  .service(
    'vdOverlayService',
    function ($document, $rootScope, vdModalsContainerService) {
      let $vdOverlayElement

      /**
       * Creates the overlay, and overlay if it doesn't already exist.
       *
       * @private
       * @method _createOverlay
       */
      function _createOverlay() {
        // Only create overlay if one doesn't already exist.
        if (!$vdOverlayElement) {
          $vdOverlayElement = angular.element(VD_OVERLAY_TEMPLATE)
          vdModalsContainerService
            .getModalsContainerElement()
            .append($vdOverlayElement)
        }
      }

      /**
       * Overlay click event handler, broadcasts an event on the rootscope that overlay was clicked
       *
       * @private
       * @method _clickHandler
       */
      function _clickHandler() {
        $rootScope.$emit(VD_EVENTS.vdOverlayClicked)
      }

      /**
       * Opens the passed overlay directive element.
       *
       * @method showOverlay
       */
      this.showOverlay = () => {
        _createOverlay()
        $vdOverlayElement.on('click', _clickHandler)
        $document[0].dispatchEvent(new Event('vend-ui-overlay-opened'))
      }

      /**
       * Determine if the overlay is visible.
       *
       * @method isVisible
       *
       * @return {Boolean} True if the overlay is visible, false otherwise
       */
      this.isVisible = () => {
        return Boolean($vdOverlayElement)
      }

      /**
       * Closes the overlay directive element.
       *
       * @method hideOverlay
       */
      this.hideOverlay = () => {
        if ($vdOverlayElement) {
          $vdOverlayElement.remove()
          $vdOverlayElement = null
        }
      }
    }
  )
